import axios from 'axios';

const fetchClientSettings = async () => {
    try {
        const response = await axios.get('/api/shop/v1/client/info.json')
        return response.data
    } catch (err) {
        throw (err)
    }
};

const callAWaiter = async (tableId) => {
    try {
        const response = await axios.post('/api/shop/v1/calls/waiter', { table_id: tableId })
        return response.data
    } catch (err) {
        throw (err)
    }
}

export {
    fetchClientSettings,
    callAWaiter
}